export function getdata() {
	var obj = {
		headData: [{
				title: "操作",
				prop: "cz",
				width: "150px",
				custom: true,
			},
			{
				title: "序号",
				prop: "Serial",
				width: 130,
				custom: true
			},
			{
				title: "明细内容",
				prop: "Details",
				width: 130,
				custom: true
			},
			{
				title: "持有收益",
				children: [{
						title: "账载金额",
						children: [{
							title: "1",
							prop: "AmountA",
							width: 130,
							custom: true,
						}]
					},
					{
						title: "税收金额",
						children: [{
							title: "2",
							prop: "TaxAmount",
							width: 130,
							custom: true,
						}]
					},
					{
						title: "纳税调整金额",
						children: [{
							title: "3",
							prop: "TaxAdjustment",
							width: 130,
							custom: true,
						}],
					}
				]
			}, {
				title: "处置收益",
				children: [{
					title: "会计确认的处置收入",
					children: [{
						title: "4",
						prop: "DisposalIRBA",
						width: 130,
						custom: true,
					}],
				}, {
					title: "税收计算的处置收入",
					children: [{
						title: "5",
						prop: "DisposalICBT",
						width: 130,
						custom: true,
					}],
				}, {
					title: "处置投资的账面价值",
					children: [{
						title: "6",
						prop: "BookVDI",
						width: 130,
						custom: true,
					}],
				}, {
					title: "处置投资的计税基础",
					children: [{
						title: "7",
						prop: "TaxDasisDI",
						width: 130,
						custom: true,
					}],
				}, {
					title: "会计确认的处置所得或失去",
					children: [{
						title: "8",
						prop: "DisposalDILRA",
						width: 130,
						custom: true,
					}],
				}, {
					title: "税收的计算的处置所得",
					children: [{
						title: "9",
						prop: "DisposalDITC",
						width: 130,
						custom: true,
					}],
				}, {
					title: "纳税调整金额",
					children: [{
						title: "10",
						prop: "TaxAamount",
						width: 130,
						custom: true,
					}],
				}, ]
			},
			{
				title: "纳税调整金额",
				children: [{
					title: "11",
					prop: "AdjustmentA",
					width: 130,
					custom: true,
				}],
			},
		],
		tableData: [{
			Serial: '',
			Details: '',
			AmountA: '',
			TaxAmount: '',
			TaxAdjustment: '',
			DisposalIRBA: '',
			DisposalICBT: '',
			BookVDI: '',
			TaxDasisDI: '',
			DisposalDILRA: '',
			DisposalDITC: '',
			TaxAamount: '',
			AdjustmentA: '',
		}, {
			Serial: '',
			Details: '',
			AmountA: '',
			TaxAmount: '',
			TaxAdjustment: '',
			DisposalIRBA: '',
			DisposalICBT: '',
			BookVDI: '',
			TaxDasisDI: '',
			DisposalDILRA: '',
			DisposalDITC: '',
			TaxAamount: '',
			AdjustmentA: '',
		}, ]
	}
	return obj
}
